/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetCheckoutRedeliveries200ResponseAllOfData } from './GetCheckoutRedeliveries200ResponseAllOfData';
import {
    GetCheckoutRedeliveries200ResponseAllOfDataFromJSON,
    GetCheckoutRedeliveries200ResponseAllOfDataFromJSONTyped,
    GetCheckoutRedeliveries200ResponseAllOfDataToJSON,
} from './GetCheckoutRedeliveries200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetCheckoutRedeliveries200Response
 */
export interface GetCheckoutRedeliveries200Response {
    /**
     * 
     * @type {GetCheckoutRedeliveries200ResponseAllOfData}
     * @memberof GetCheckoutRedeliveries200Response
     */
    data: GetCheckoutRedeliveries200ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof GetCheckoutRedeliveries200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the GetCheckoutRedeliveries200Response interface.
 */
export function instanceOfGetCheckoutRedeliveries200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function GetCheckoutRedeliveries200ResponseFromJSON(json: any): GetCheckoutRedeliveries200Response {
    return GetCheckoutRedeliveries200ResponseFromJSONTyped(json, false);
}

export function GetCheckoutRedeliveries200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCheckoutRedeliveries200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetCheckoutRedeliveries200ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function GetCheckoutRedeliveries200ResponseToJSON(value?: GetCheckoutRedeliveries200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetCheckoutRedeliveries200ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

